<template>
  <div class="segment-wrap">
    <div class="segment-control">
      <div class="horiz" :style="horizStyle"></div>
      <button
        v-for="(tab, index) in listOptionTab"
        :key="index"
        ref="btnRefs"
        class="segment-btn"
        :class="{ on: tab.value === activeTab }"
        @click="onTabClick(tab.value, index)"
      >
        {{ tab.label }}

        <div class="badge sale-badge" v-if="tab.value === 'ANNUAL'">{{ t('discount_rate', { discount: 20 }) }}</div>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Option } from '@/types/composables';
const { t, locale } = useI18n();

const props = withDefaults(
  defineProps<{
    listOptionTab: Option[];
    activeTab: string | number;
    size?: string;
  }>(),
  {
    size: 'small',
  }
);
const emit = defineEmits(['tabClick']);

// Montly / Yearly 클릭 시
//  버튼 엘리먼트들을 참조할 배열 ref
const btnRefs = ref<HTMLElement[]>([]);

//  배경 바 스타일 상태
const horizStyle = ref({
  width: '0px',
  left: '0px',
});

// 위치 계산 및 이동 함수
const moveHoriz = (index: number) => {
  const btn = btnRefs.value[index];
  if (!btn) return;

  horizStyle.value = {
    width: `${btn.offsetWidth}px`,
    left: `${btn.offsetLeft}px`,
  };
};

// 탭 클릭 시: 부모에게 알리고 모션 실행
const onTabClick = (tabValue: string | number, index: number) => {
  moveHoriz(index); // 즉시 해당 인덱스로 배경 이동
  emit('tabClick', tabValue);
};

// 초기 로딩 시 위치 잡기
onMounted(async () => {
  await nextTick();
  const activeIndex = props.listOptionTab.findIndex((t) => t.value === props.activeTab);
  if (activeIndex !== -1) {
    moveHoriz(activeIndex);
  }
});

watch(
  () => props.activeTab,
  async () => {
    await nextTick();
    const index = props.listOptionTab.findIndex((t) => t.value === props.activeTab);
    if (index !== -1) moveHoriz(index);
  }
);

watch(locale, async () => {
  await nextTick();
  const index = props.listOptionTab.findIndex((tab) => tab.value === props.activeTab);
  if (index !== -1) moveHoriz(index);
});
</script>

<style scoped lang="scss">
.segment-control {
  background: $gray10;
}
.sale-badge {
  border: 1px solid $color-navy-100;
  background: $primary-bg;
  color: $color-navy-100;
  font-size: $font-size-psmall;
}
</style>
